/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';

function FormInput({ labelFor, label, placeholder, id, type, name, value, onChange }) {
    return (
        <div className="col-md-6 col-12">
            <div className="single-personal-info">
                <label htmlFor={labelFor}>{label}</label>
                <input
                    value={value}
                    onChange={onChange}
                    type={type}
                    id={id}
                    name={name}
                    placeholder={placeholder}
                />
            </div>
        </div>
    );
}

export default FormInput;
